import { api } from "../store/middleware/api";

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    addMenu: build.mutation({
      query: (body) => ({
        url: `/admin/menu/add`,
        method: "POST",
        body,
      }),
    }),
    getDishesCountryVise: build.query({
      query: (country) => `/dish`
    }),
    updateMenu: build.mutation({
      query: (body) => ({
        url: "/admin/menu/update",
        method: "POST",
        body,
      }),
    }),
    deleteMenu: build.mutation({
      query: (body) => ({
        url: "/admin/menu/delete",
        method: "POST",
        body,
      }),
    }),
    getSingleMenu: build.query({
      query: (id) => ({
        url: `/menu/${id}`,
      }),
    }),
    getSearchedMenu: build.query({
      query: (body) => ({
        url: "/admin/menu/search/dish",
        method: "POST",
        body,
      }),
    }),
    getMenuCountryVise: build.query({
      query: () => `/menu`,
    }),
    addToFav: build.mutation({
      query: (body) => ({
        url: "/mealplane/favourite",
        method: "POST",
        body,
      }),
    }),
    getFavourites: build.query({
      query: () => `/mealplane/favourite/get`,

    })
  }),
  overrideExisting: false,
});

export const {
  useAddMenuMutation,
  useUpdateMenuMutation,
  useGetSingleMenuQuery,
  useGetSearchedMenuQuery,
  useGetMenuCountryViseQuery,
  useGetDishesCountryViseQuery,
  useAddToFavMutation,
  useGetFavouritesQuery
} = extendedApi;
